// extracted by mini-css-extract-plugin
module.exports = {"back":"back_link-module__back___IAlar","back__icon":"back_link-module__back__icon___iaWfE"};